import Cookies from 'universal-cookie';
// import TagManager from 'react-gtm-module';

//controllers
import Qualidade_controller, { getGrupos, getFamilias } from '../../../../../../../controllers/qualidade';
import Config from '../../../../../../../controllers/config';
import { filterValidation } from './filterValidation';

export default (props) => {

    const loadAcessorios = async (linhaInicial, qtdRegistro) => {
        const cookies = new Cookies();
        const token = cookies.get('User-Token');

        try {
            // Dados do DropDown de Grupos
            const opcoesGrupos = await loadGrupos();
            props.setState({ opcoesGrupos });
            
            let alfaNumerico = null;
            let idFicha = null;
            let nomeProduto = null;
            let fornecedor = null;
            let linha = null;
            let idProduto = null;
            let grupo = null;
            let familia = null;

            const arrayColAlfaNumerico = props.state.colunasFilterTagsAcessorios
            .filter(element => (
                element.key === "Alfa numérico" &&
                element.value !== element.origemValue
            ));

            const arrayColIdFicha = props.state.colunasFilterTagsAcessorios
            .filter(element => (
                element.key === "Número da Ficha" &&
                element.value !== element.origemValue
            ));

            const arrayColNomeProduto = props.state.colunasFilterTagsAcessorios
            .filter(element => (
                element.key === "Nome do produto" &&
                element.value !== element.origemValue
            ));

            const arrayColLinha = props.state.colunasFilterTagsAcessorios
            .filter(element => (
                element.key === "Linha" &&
                element.value !== element.origemValue
            ));

            const arrayColIdProduto = props.state.colunasFilterTagsAcessorios
            .filter(element => (
                element.key === "ID do Produto" &&
                element.value !== element.origemValue
            ));

            if (arrayColAlfaNumerico.length > 0) { 
                alfaNumerico = arrayColAlfaNumerico[0].value;
            }

            if (arrayColNomeProduto.length > 0) {
                nomeProduto = arrayColNomeProduto[0].value;
            }

            if (arrayColLinha.length > 0) {
                linha = arrayColLinha[0].value;
            }
                
            if (arrayColIdProduto.length > 0) {
                idProduto = arrayColIdProduto[0].value;
            }

            if (arrayColIdFicha.length > 0) {
                idFicha = arrayColIdFicha[0].value;
            }
                
            const { escolhaGrupo, escolhaFamilia } = props.state;
            if (escolhaGrupo !== 0) {
                const { cd_grupo } = props.state.opcoesGrupos[escolhaGrupo];
                grupo = cd_grupo;
            }
            
            familia = escolhaFamilia === 0 ? null : escolhaFamilia;
            fornecedor = props.state.fornecedor;
            
            if (fornecedor == null) {
                fornecedor = 0;
            }
    
            const query = {
                LinhaInicial: linhaInicial,
                QtdRegistro: qtdRegistro,
                idSituacao: props.state.escolhaSituacaoAcessorios,
                Departamento: "A",
                inAcessMoveis: "A",
    
                alfaNumerico: alfaNumerico || props.state.searchFieldExternalAcessorios,
                idFicha,
                nomeProduto,
                fornecedor,
                linha,
                idProduto,
                grupo,
                familia,
            };
            const o_qualidade = await Qualidade_controller.get(token,query);
            const j_o_qualidade = JSON.parse(o_qualidade.body);

            if (o_qualidade.res.statusCode === 200) {
                
                const arrayItens = j_o_qualidade.map(e => {
                    return {
                        ...e,
                        produtos: [],
                    };
                });

                const validaItensAcessorios = arrayItens.length > 0;
                props.setState({
                    dataAcessorios: validaItensAcessorios ? arrayItens : [],
                    totalRowsAcessorios: validaItensAcessorios ? arrayItens[0].qt_total_regs : 0,
                });

                // TagManager.dataLayer({
                //     dataLayer: {
                //       event: 'event',
                //       eventCategory: 'tokstok:fornecedores:qualidade',
                //       eventAction: 'callback',
                //       eventLabel: `sucesso`,
                //     }
                // });
                
            } else {
                if (
                    o_qualidade.res.statusCode === 200 && 
                    j_o_qualidade.message && 
                    j_o_qualidade.message.includes("Token inválido!")
                ) {
                    this.child.current.retorno('Autentificação inválida!','error');
                    setTimeout(function() {
                        window.location.reload();
                    }, 1000);
                } else {
                    throw new Error("Campos necessários, não foram retornados pelo servidor!");
                }
            }
        } catch (error) {
            props.childAlert.current.retorno('Erro ao carregar dados!','error');
            let errorString = "Erro ao carregar dados!";
            if (Config.DEBUG === "TRUE")
                errorString = error.message;
            props.setState({
                isError: true,
                isLoading: false,
                error: errorString
            });

            // TagManager.dataLayer({
            //     dataLayer: {
            //       event: 'event',
            //       eventCategory: 'tokstok:fornecedores:qualidade',
            //       eventAction: 'callback',
            //       eventLabel: `erro:${error.message}`,
            //     }
            // });
        }
    };

    const loadProdutos = async (query, alfaNumerico) => {
        const cookies = new Cookies();
        const token = cookies.get('User-Token');
        
        try {
            let newDataAcessorios = props.state.dataAcessorios;
            const o_produtos = await Qualidade_controller.getProdutos(token, query);
            const j_o_produtos = JSON.parse(o_produtos.body);
            const index = newDataAcessorios.map(e=>e.alfaNumerico).indexOf(alfaNumerico);
            newDataAcessorios[index].produtos = j_o_produtos;
            if (j_o_produtos.length > 0) {
                props.setState({dataAcessorios: newDataAcessorios});
            }

            if (o_produtos.res.statusCode === 200) {
                
                props.setState({dataAcessorios: newDataAcessorios});

                // TagManager.dataLayer({
                //     dataLayer: {
                //       event: 'event',
                //       eventCategory: 'tokstok:fornecedores:acessorios',
                //       eventAction: 'callback',
                //       eventLabel: 'sucesso:lista-acessorios',
                //     }
                // });
                
            } else {
                if (
                    o_produtos.res.statusCode === 200 && 
                    j_o_produtos.message && 
                    j_o_produtos.message.includes("Token inválido!")
                ) {
                    this.child.current.retorno('Autentificação inválida!','error');
                    setTimeout(function() {
                        window.location.reload();
                    }, 1000);
                } else {
                    throw new Error("Campos necessários, não foram retornados pelo servidor!");
                }
            }
        } catch (error) {
            props.childAlert.current.retorno('Erro ao carregar dados!','error');
            let errorString = "Erro ao carregar dados!";
            if (Config.DEBUG === "TRUE")
                errorString = error.message;
            props.setState({
                isError: true,
                isLoading: false,
                error: errorString
            });

            // TagManager.dataLayer({
            //     dataLayer: {
            //       event: 'event',
            //       eventCategory: 'tokstok:fornecedores:qualidade',
            //       eventAction: 'callback',
            //       eventLabel: `erro:${error.message}`,
            //     }
            // });
        }
    };
    
    const toBase64 = file => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });
    
    const sendFile = async (params,file) => {
        // const cookies = new Cookies();
        // const token = cookies.get('User-Token');

        // const formData = new FormData();
        // const base64 = await toBase64(file);
        // formData.append("Alfanumerico", params.alfaNumerico);
        // formData.append("FileName", file.name);
        // formData.append("ContentFile", file.type);
        // formData.append("Doc", base64.split(",")[1]);
        // formData.append("idUserFornecedor", params.id_fornecedor);
        // formData.append("Departamento", "A");
        // formData.append("InStatus", "A");
        
        // const o_qualidade = await Qualidade_controller.postFile(token,formData);

        // if (o_qualidade.status == 200) {
        //     // const j_o_qualidade = JSON.parse(o_qualidade.body);
        //     await props.setState({openModalUpFichaTecnica: true});
        // }

        // await props.setState({lastCardSelected: null});
        // props.childUploadAcessorios.value = "";
        
        // return;
    };

    const handlerLoadSearchFilterTagAcessorios = () => {
        let newColunasFilterTags = props.state.colunasFilterTagsAcessorios;
        for (let i = 0; i < props.state.colunasAcessorios.length; i++) {
            newColunasFilterTags.push({
                key: props.state.colunasAcessorios[i].key,
                value: props.state.searchFieldAcessorios,
                origemValue: ""
            });
        }
        props.setState({colunasFilterTagsAcessorios: newColunasFilterTags});
    };

    const handlerSelectCheckboxAcessorios = (params) => {
        let newArray = props.state.dataAcessoriosSelected;
        const index = newArray.indexOf(params);
        if (index > -1) {
            newArray.splice(index, 1);
        } else {
            newArray.push(params);
        }
        props.setState({dataAcessoriosSelected: newArray});
    };

    const handlerClickCheckboxAcessorios = (i) => {
        const { isFilterTypeValid } = filterValidation({
            setSnackbarMessage: props.setMessageSnackbarFilterValidation,
            toggleSnackbar: props.toggleSnackbarFilterValidation,
        });

        const filterKey = props.state.colunasAcessorios[i].key;
        const filterValue = props.state.searchFieldAcessorios;

        if(isFilterTypeValid(filterKey, filterValue)) {
            let colunms = props.state.colunasAcessorios;
            colunms[i].value = !(props.state.colunasAcessorios[i].value);
            props.setState({colunasAcessorios: colunms});

            props.handlerChangeSearchFilterTagAcessorios(i);
        }
    };

    const handlerClearCheckboxAcessorios = () => {
        let colunms = props.state.colunasAcessorios;
        props.state.colunasAcessorios.forEach(element => {
            element.value = false;
        });
        props.setState({colunasAcessorios: colunms});
    };

    const handlerChangeSearchFilterTagAcessorios = (i) => {
        let newColunasFilterTags = props.state.colunasFilterTagsAcessorios;

        const nameObject = props.state.colunasAcessorios[i].key;

        const indexObject = props.state.colunasFilterTagsAcessorios.map(e=>e.key).indexOf(nameObject);

        if (indexObject < 0) return;
        
        if (props.state.colunasAcessorios[i].value) {
            newColunasFilterTags[indexObject].value = props.state.searchFieldAcessorios;
        } else {
            newColunasFilterTags[indexObject].value = "";
        }
        
        props.setState({colunasFilterTagsAcessorios: newColunasFilterTags});
    };

    const handlerClearFilterTagAcessorios = (i) => {
        let newColunasFilterTags = props.state.colunasFilterTagsAcessorios;
        if (newColunasFilterTags[i] == null) return;
        newColunasFilterTags[i].value = newColunasFilterTags[i].origemValue;
        props.setState({colunasFilterTagsAcessorios: newColunasFilterTags});

        const index = props.state.colunasAcessorios.map((e)=>{return e.key}).indexOf(newColunasFilterTags[i].key);
        if (index < 0) return;
        let colunms = props.state.colunasAcessorios;
        colunms[index].value = false;
        props.setState({colunasAcessorios: colunms});
    };

    const handlerChangeStatusAcessorios = async (event) => {
        await props.setState({statusAcessorios: event.target.value});
        
        await props.setState({isLoading: true});
        await props.loadAcessorios(0, props.state.rowsPerPageAcessorios);
        await props.setState({isLoading: false});
    };
    
    const handlerChangeSituacoesAcessorios = (event) => {
        props.setState({escolhaSituacaoAcessorios: event.target.value});
    };

    const handlerCleanFiltersAcessorios = () => {
        props.state.colunasFilterTagsAcessorios.forEach((element,i) => {
            props.handlerClearFilterTagAcessorios(i);
        });
        props.setState({
            searchFieldAcessorios: "",
            escolhaGrupo: 0,
            escolhaFamilia: 0,
            escolhaSituacaoAcessorios: 0,
            isSelectFamiliasAcessoriosDisabled: true,
        });
    };

    const handlerAplicarFiltersAcessorios = async () => {
        await props.setState({isLoading: true});
        await props.loadAcessorios(0, props.state.rowsPerPageAcessorios);
        await props.setState({isLoading: false});
    };

    const handlerCheckboxAllAcessorios = async (event) => {
        if (props.state.dataAcessoriosSelected.length == props.state.totalRowsAcessorios) {
            await props.setState({dataAcessoriosSelected: []});
        } else {
            await props.loadAcessorios(0,props.state.totalRowsAcessorios);
            await props.setState({dataAcessoriosSelected: props.state.dataAcessorios});
            await props.loadAcessorios(props.state.pageInitialAcessorios,props.state.pageRowsAcessorios);
            await props.setState({isLoading:false});
        }
    };
    
    const handlerChangeSearchFieldAcessorios = (event) => {
        event.persist();
        props.setState({searchFieldAcessorios: event.target.value});
    };
    
    const handlerChangeSearchFieldExternalAcessorios = (event) => {
        event.persist();
        props.setState({searchFieldExternalAcessorios: event.target.value});
    };

    const handlerClickSearchFieldExternalAcessorios = async () => {
        await props.setState({isLoading: true});
        await props.loadAcessorios(0, props.state.rowsPerPageAcessorios);
        await props.setState({isLoading: false});
    };

    const onChangePageAcessorios = async (pageFrom) => {
        await props.setState({isLoading: true});
        await props.loadAcessorios(pageFrom, props.state.rowsPerPageAcessorios);
        await props.setState({pageFrom});
        await props.setState({isLoading: false});
    };

    const onChangeFileAcessorios = async (event) => {
        event.stopPropagation();
        event.preventDefault();
        if (!event.cancelable) {
            const file = event.target.files[0];
            const sizeInMB = (file.size / (1024*1024)).toFixed(2);
            if (file.type === "") {
                props.childAlert.current.retorno('É necessário especificar uma extensão ao arquivo!','warning');
                return;
            }
            if (file.type !== "application/pdf") {
                props.childAlert.current.retorno('Extensão precisa ser pdf!','warning');
                return;
            }
            if (sizeInMB > 7) {
                props.childAlert.current.retorno('Tamanho do arquivo precisa ser inferior a 7mb!','warning');
                return;
            }
            
            await props.setState({isLoading: true});
            await sendFile(props.state.lastCardSelected,file);
            await props.setState({isLoading: false});
            await props.setState({lastCardSelected: null});
        }
    };

    const onClickViewModalAcessorios = async (atributos) => {
        if (atributos.status === "Aprovado") {
            await props.setState({ isLoading: true });
            const query = {
                P_ID_PESSOA: props.state.fornecedor,
                P_ID_DESCR: atributos.idDescr
            }
            await loadProdutos(query, atributos.alfa);
            await props.setState({isLoading: false});
        }
    };

    const onUpFileAcessorios = async (atributos) => {
        props.childUploadAcessorios.click();
        props.setState({lastCardSelected: atributos});
    };

    const loadGrupos = async () => {
        const cookies = new Cookies();
        const token = cookies.get('User-Token');
        const params = { inAcessMoveis: "A" }

        const response = await getGrupos({ token, params }).then((response) => JSON.parse(response.body));

        const grupos = addDefaultSelectOption(response);
        return grupos;
    }

    const addDefaultSelectOption = (grupos) => {
        grupos.unshift({
            cd_grupo: 0,
            nm_grupo: "Selecione um grupo",
            cd_div: 0,
        });
        return grupos.sort((a, b) => (a.cd_grupo > b.cd_grupo) ? 1 : -1);
    };

    const handleChangeGruposAcessorios = async (event) => {
        const escolhaGrupo = event.target.value;
        props.setState({ escolhaGrupo });
        try {
          await loadFamilias({ escolhaGrupo });
        } catch (error) {
          console.error(error);
        }
    };

    const loadFamilias = async ({ escolhaGrupo }) => {
        const cookies = new Cookies();
        const token = cookies.get("User-Token");
        const params = getParamsLoadFamilias({ escolhaGrupo });
        
        await getFamilias({ token, params })
        .then((response) => JSON.parse(response.body))
        .then((body) => {
            const opcoesFamilias = addDefaultSelectOptionFamilias(body);
            
            props.setState({
                opcoesFamilias,
                isSelectFamiliasAcessoriosDisabled: false
            });
        });
    };

    const addDefaultSelectOptionFamilias = (familias) => {
        familias.unshift({
            cd_familia: 0,
            nm_familia: "Selecione uma família",
        });
        return familias.sort((a, b) => (a.cd_familia > b.cd_familia) ? 1 : -1);
    };

    const getParamsLoadFamilias = ({ escolhaGrupo }) => {
        const { cd_grupo: cdGrupo, cd_div: cdDiv } = props.state.opcoesGrupos[escolhaGrupo];
        return { cdGrupo, cdDiv };
    };

    const handleChangeFamiliasAcessorios = (event) => {
        props.setState({ escolhaFamilia: event.target.value });
    };

    const disableSelectFamilias = () => {
        props.setState({
            isSelectFamiliasAcessoriosDisabled: true,
        });
    };

    return {
        loadAcessorios,
        handlerLoadSearchFilterTagAcessorios,
        handlerSelectCheckboxAcessorios,
        handlerClickCheckboxAcessorios,
        handlerClearCheckboxAcessorios,
        handlerChangeSearchFilterTagAcessorios,
        handlerClearFilterTagAcessorios,
        handlerChangeStatusAcessorios,
        handlerChangeSituacoesAcessorios,
        handlerCleanFiltersAcessorios,
        handlerAplicarFiltersAcessorios,
        handlerCheckboxAllAcessorios,
        handlerChangeSearchFieldAcessorios,
        handlerChangeSearchFieldExternalAcessorios,
        handlerClickSearchFieldExternalAcessorios,
        onChangePageAcessorios,
        onClickViewModalAcessorios,
        onChangeFileAcessorios,
        onUpFileAcessorios,
        handleChangeGruposAcessorios,
        handleChangeFamiliasAcessorios,
        disableSelectFamilias,
    };
};